import { useQuery } from "@tanstack/react-query";

import { capabilityService } from "./capabilityService";
import type { CapabilityCard } from "../model/types";
import { CLUSTER_ORDER, type CapabilityCluster } from "../model/clusters";

/**
 * 能力舱卡片(挂了 cluster 的舱)。唯一来源 = 后端 xb_module_catalog(经 /me/modules/capabilities)。
 * 首页 5 群卡墙、上下文侧栏能力区、⌘K 命令面板共用;后端加/挪/转态一处生效,前端零改动同步。
 */
export function useCapabilities() {
  return useQuery<CapabilityCard[]>({
    queryKey: ["me", "capabilities"],
    queryFn: capabilityService.listCapabilities,
    staleTime: 5 * 60_000,
  });
}

/**
 * 按 cluster 分组(保持 CLUSTER_ORDER 群序 + 组内 catalog id 序)。空群不产键。
 * data 未到(undefined)→ 空 map,调用方按 CLUSTER_ORDER 兜底即可。
 */
export function groupByCluster(
  cards: CapabilityCard[] | undefined
): Map<CapabilityCluster, CapabilityCard[]> {
  const out = new Map<CapabilityCluster, CapabilityCard[]>();
  for (const cluster of CLUSTER_ORDER) {
    const inCluster = (cards ?? []).filter((c) => c.cluster === cluster);
    if (inCluster.length > 0) out.set(cluster, inCluster);
  }
  return out;
}
